import { useAppSelector } from '~/hooks/useAppSelector';

export const useIsWorkerClassificationEnabled = () => {
  const stateWorkerClassification = useAppSelector((state) => state.user.stateWorkerClassification);
  return stateWorkerClassification?.contractor && stateWorkerClassification?.employee;
};
